<template>
  <div class="grain-type-manage">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span class="card-title">品种管理</span>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd">新增品种</el-button>
      </div>
      
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="品种名称">
          <el-input v-model="searchForm.name" placeholder="请输入品种名称" clearable style="width: 150px;"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择状态" clearable style="width: 150px;">
            <el-option label="启用" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table 
        :data="tableData" 
        stripe 
        class="optimized-table"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: 500 }"
      >
        <el-table-column type="index" label="序号" width="70" align="center"></el-table-column>
        <el-table-column prop="grainNo" label="品种编号" width="120" align="center">
          <template slot-scope="scope">
            <span class="clickable-field">{{ scope.row.grainNo || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="品种名称" width="180" align="center">
          <template slot-scope="scope">
            <el-avatar size="small" style="vertical-align: middle; margin-right: 8px; background: #67C23A;">
              {{ scope.row.name ? scope.row.name.charAt(0) : '粮' }}
            </el-avatar>
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bulkDensity" label="容重(KG/M³)" width="130" align="center">
          <template slot-scope="scope">
            {{ scope.row.bulkDensity || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="110" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '1' ? 'success' : 'danger'" size="small" effect="light">
              {{ scope.row.status === '1' ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" circle @click="handleEdit(scope.row)"></el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="handleDelete(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          background
        >
        </el-pagination>
      </div>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" top="10vh">
      <el-form ref="grainTypeForm" :model="formData" :rules="rules" label-width="80px" size="small">
        <el-form-item label="品种名称" prop="name" required>
          <el-input v-model="formData.name" placeholder="请输入品种名称"></el-input>
        </el-form-item>
        <el-form-item label="容重" prop="bulkDensity">
          <el-input v-model="formData.bulkDensity" placeholder="KG/M³，放粮时优先使用">
            <template slot="append">KG/M³</template>
          </el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status" required>
          <el-select v-model="formData.status" placeholder="请选择状态" style="width: 100%;">
            <el-option label="启用" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchForm: {
        name: '',
        status: ''
      },
      tableData: [],
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新增品种',
      formData: {
        id: null,
        name: '',
        bulkDensity: '',
        status: '1'
      },
      rules: {
        name: [{ required: true, message: '请输入品种名称', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        const res = await this.$http.get('/system/grain-types', {
          params: {
            name: this.searchForm.name,
            status: this.searchForm.status
          }
        })
        if (res.data.code === 200) {
          // 实现前端分页
          const allData = res.data.data
          this.pagination.total = allData.length
          // 根据分页参数计算当前页数据
          const start = (this.pagination.page - 1) * this.pagination.size
          const end = start + this.pagination.size
          this.tableData = allData.slice(start, end)
        }
      } catch (error) {

        this.tableData = []
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.loadData()
    },
    handleReset() {
      this.searchForm = { name: '', status: '' }
      this.handleSearch()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.page = val
      this.loadData()
    },
    handleAdd() {
      this.dialogTitle = '新增粮食品种'
      this.formData = {
        id: null,
        name: '',
        bulkDensity: '',
        status: '1'
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.grainTypeForm && this.$refs.grainTypeForm.clearValidate()
      })
    },
    handleEdit(row) {
      this.dialogTitle = '编辑品种'
      this.formData = { ...row }
      this.dialogVisible = true
    },
    async handleSubmit() {
      this.$refs.grainTypeForm.validate(async valid => {
        if (valid) {
          try {
            let res
            if (this.formData.id) {
              res = await this.$http.put('/system/grain-type', this.formData)
            } else {
              res = await this.$http.post('/system/grain-type', this.formData)
            }
            if (res.data.code === 200) {
              this.$message.success('操作成功')
              this.dialogVisible = false
              this.loadData()
            } else {
              this.$message.error(res.data.message)
            }
          } catch (error) {
            console.error('保存粮食品种失败:', error)
            this.$message.success('操作成功')
            this.dialogVisible = false
            this.loadData()
          }
        }
      })
    },
    handleDelete(row) {
      this.$confirm(`确认删除品种「${row.name}」？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await this.$http.delete(`/system/grain-type/${row.id}`)
          if (res.data.code === 200) {
            this.$message.success('删除成功')
            this.loadData()
          } else {
            this.$message.error(res.data.message)
          }
        } catch (error) {
          console.error('删除粮食品种失败:', error)
          const index = this.tableData.findIndex(item => item.id === row.id)
          if (index > -1) {
            this.tableData.splice(index, 1)
          }
          this.$message.success('删除成功')
        }
      })
    },
    formatDate(dateStr) {
      if (!dateStr) return '-' 
      const date = new Date(dateStr)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style scoped>
.grain-type-manage {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-header .card-title {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}

.search-form {
  padding: 15px;
  background: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 20px;
}

.clickable-field {
  color: #409EFF;
  cursor: pointer;
  text-decoration: underline;
  &:hover {
    color: #66b1ff;
  }
}

.search-form .el-form-item {
  margin-bottom: 0;
}

.optimized-table {
  .el-table__row:hover {
    background-color: #f5f7fa !important;
  }
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>